export default __webpack_public_path__ + "static/media/tdex-no-color.115b378e.svg";